import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path d="M11.808 4.615c-3.231 0-5.846 2.616-5.846 5.877 0 4.062 4.184 7.785 5.476 8.77.216.184.524.184.77 0 1.292-1.016 5.446-4.708 5.446-8.77 0-3.261-2.616-5.877-5.846-5.877zm0 8.308a2.469 2.469 0 01-2.462-2.461A2.469 2.469 0 0111.808 8a2.469 2.469 0 012.461 2.462 2.469 2.469 0 01-2.461 2.461z" /></svg>);